import type { ShownEvent } from '@/hooks/useEvents'
import type { People } from '@/hooks/usePeople'
import type { CalendarOwner } from '@/types'

// Whose colour an event takes and how its calendar is named, shared by the
// event chips, the event card and the Calendar's grids. Kept apart from
// Events.tsx so that file exports only components.

export type EventTone = 'p1' | 'p2' | 'both'

/** The person tone an event takes: the owner's colour, or neutral for a calendar marked Both. */
export function eventTone(owner: CalendarOwner, people: People): EventTone {
  if (owner === 'me') return people.toneOf(people.meUid)
  if (owner === 'other' && people.other) return people.toneOf(people.other.uid)
  return 'both'
}

/** "Chris's calendar", or the calendar's own name for one marked Both. */
export function whoseCalendar(ev: ShownEvent, people: People, calendarName: string): string {
  if (ev.owner === 'me') return `${people.names[people.meUid] ?? 'Your'}'s calendar`
  if (ev.owner === 'other' && people.other) return `${people.other.name}'s calendar`
  return calendarName
}
